"use client";
import { Heading, Wrap, Stack, WrapItem, GridProps, Text } from "@chakra-ui/react";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import Card, { CardProps } from "../cardsList/card";

type Props = {
  title?: string;
  desc?: string;
  list: CardProps[];
  Width?: any;
  spacing?: GridProps["gridGap"];
};

const WrapCards = (props: Props) => {
  const {
    title,
    desc,
    list,
    Width = {
      base: "100%",
      sm: "40vw",
      md: "26vw",
      xl: "26vw",
      "2xl": "480px",
    },
    spacing = { base: 8, sm: "5vw", md: "5vw", xl: "2vw", "2xl": 12 },
  } = props;
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={8}>
      {title && (
        <Heading as="h1" variant={HeadingVariant} textAlign={"center"}>
          {title}
        </Heading>
      )}
      {desc && (
        <Text variant={TextVariant} textAlign={"center"} color="text.100">
          {desc}
        </Text>
      )}
      <Wrap spacing={spacing} justify={"center"}>
        {list.map((item, index) => (
          <WrapItem key={index} w={Width} alignItems={"stretch"}>
            <Card key={index} {...item} />
          </WrapItem>
        ))}
      </Wrap>
    </Stack>
  );
};

export default WrapCards;
